module.exports = __webpack_public_path__ + "static/media/Google__G__Logo.svg.2ca34c6b.webp";